import {AttachMoney, Event, Loop, People, Schedule, Category} from "@material-ui/icons";
import {Box } from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {format} from "date-fns";
import Icon from '@material-ui/core/Icon';
import React from 'react';
import { loadCSS } from 'fg-loadcss';

const useStyles = makeStyles((theme) => ({
    indicatorWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        // justifyContent: 'centre',
        marginLeft: 40
    },
    indicator: {
        display: 'flex',
        alignItems: 'center',
        margin: theme.spacing(0,1),
        '& p': {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(15),
            color: theme.palette.text.secondary,
        }
    }
}))
export default function IndicatorList({activity}) {
    const classes = useStyles();
    const indicators = [];
    React.useEffect(() => {
        const node = loadCSS(
          'https://use.fontawesome.com/releases/v5.12.0/css/all.css',
          document.querySelector('#font-awesome-css'),
        );
    
        return () => {
          node.parentNode.removeChild(node);
        };
      }, []);

    if (!!activity.info.category) {
        indicators.push(
            <div className={classes.indicator} key="category">
                <Category/>
                <p>Category - {activity.info.category.name} </p>
            </div>
        );
    }
    if (!!activity.info.max_capacity) {
        indicators.push(
            <div className={classes.indicator} key="people">
                <People/>
                <p>Max {activity.info.max_capacity} people</p>
            </div>
        );
    }
    if (!!activity.info.cost) {
        indicators.push(
            <div className={classes.indicator} key="cost">
                <Icon className="fas fa-coins" />
                <p> {activity.info.cost.currency} {activity.info.cost.cost} </p>
            </div>
        );
    }
    if (activity.hasOwnProperty('isRecurring') && activity.isRecurring) {
        const copy = [...activity.recurringDays];
        const last = copy.pop();
        indicators.push(
            <div className={classes.indicator} key="recurring">
                <Loop/>
                <p> Recurs weekly on {copy.join(', ')} and {last}</p>
            </div>
        );
    }
    if ( activity.startDate != null && activity.endDate != null) {
        indicators.push(
            <div className={classes.indicator} key="dayindicator">
                <Event />
                <p>
                    {format(new Date(activity?.startDate?.toString()), 'P')}
                    -
                    {format(new Date(activity?.endDate?.toString()), 'P')}
                </p>
            </div>
        )
    }
    if (activity.hasOwnProperty('isFullDay')
        && !activity.isFullDay
        && activity.startTime != null
        && activity.endTime != null
    ) {
        indicators.push(
            <div className={classes.indicator} key="time">
                <Schedule/>
                <p>
                    {format(new Date(activity?.startTime?.toString()), 'p')}
                    -
                    {format(new Date(activity?.endTime?.toString()), 'p')}
                </p>
            </div>
        )
    }


    return (<Box className={classes.indicatorWrapper}> {indicators} </Box>)
}
